// services/LoadingManagementService.js (or wherever this is)
import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';

const user = getLoggedUser();
const endpoint = apiUrl + 'v2';

async function getDeliverySitesList(filters = {}) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const response = await axios.get(`${endpoint}/selectors/delivery-sites?${query}`, config);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getVehiclesForSite(siteId, filters = {}) {
  // Convert filters object to query string
  const query = new URLSearchParams(filters).toString();
  
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    // Build the URL correctly - siteId goes in the path, filters in query string
    const url = `${endpoint}/delivery-sites/${siteId}/vehicles${query ? '?' + query : ''}`;
    
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error('Error fetching delivery site vehicles:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function createWeighbridgeTicket(payload, isFormData = false) {
  const user = getLoggedUser(); // Make sure this is available
  
  const config = {
    headers: {
      Authorization: 'Bearer ' + user.token,
    },
  };

  // If it's FormData, don't set Content-Type (browser will set it)
  // If it's JSON, set Content-Type to application/json
  if (!isFormData) {
    config.headers['Content-Type'] = 'application/json';
  }

  try {
    const { data: response } = await axios.post(
      `${endpoint}/weighbridge-tickets`, 
      payload, 
      config
    );
    
    // Return the response data
    return response;
  } catch (error) {
    console.error('API Error:', error);
    
    // Return a consistent error response structure
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
    };
  }
}

async function exitWeighbridgeTicket(payload, isFormData = false, id) {
  const user = getLoggedUser();
  
  const config = {
    headers: {
      Authorization: 'Bearer ' + user.token,
    },
  };

  // Don't set Content-Type for FormData (browser will set it with boundary)
  if (!isFormData) {
    config.headers['Content-Type'] = 'application/json';
  }

  try {
    const { data: response } = await axios.post(
      `${endpoint}/weighbridge-tickets/${id}/exit`, 
      payload, 
      config
    );
    
    return response;
  } catch (error) {
    console.error('API Error:', error);
    
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      errors: error.response?.data?.errors || null,
      status: error.response?.status || 500,
    };
  }
}



async function getWeighbridgeTickets(filters = {}) {
  // Convert filters object to query string
  const query = new URLSearchParams(filters).toString();
  
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    // Build the URL correctly - siteId goes in the path, filters in query string
    const url = `${endpoint}/weighbridge-tickets?${query}`;
    
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error('Error fetching delivery site vehicles:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}
export {  getDeliverySitesList  , getVehiclesForSite , createWeighbridgeTicket , getWeighbridgeTickets , exitWeighbridgeTicket};